/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import { DialogDefaultV2 } from '../../../components/v2';

const ComoFuncionaDialog = ({ open, onClose }) => (
  <DialogDefaultV2
    open={open}
    handlerCancel={onClose}
    handlerConfirm={onClose}
    title="Como funciona"
    maxWidth="sm"
    fullWidth
    useFullScreen={false}
    readOnly
  >
    <Stack spacing={1.5}>
      <Typography variant="body2">
        Esta tela tem três momentos. Você não precisa fazer tudo de uma vez.
      </Typography>
      <Stack spacing={0.75}>
        <Typography variant="body2">
          <strong>1. Itens.</strong>
        </Typography>
        <Typography variant="body2">
          Decida cada linha: Aprovar (sai do estoque e gera pedido de saída), Rejeitar
          (não atende) ou Para pedido (cria o pedido de almoxarifado ligado ao item).
          Isso grava na hora. Enquanto o item não estiver numa entrega, use Alterar para
          corrigir a decisão.
        </Typography>
      </Stack>
      <Stack spacing={0.75}>
        <Typography variant="body2">
          <strong>2. Pedidos.</strong>
        </Typography>
        <Typography variant="body2">
          Esta aba lista os pedidos de almoxarifado ligados aos itens: saída quando
          Aprovar, entrada quando Para pedido. Sem status e sem Receber. Depois de
          gravar, o item já pode ir para entrega. O link também aparece na linha do item.
        </Typography>
      </Stack>
      <Stack spacing={0.75}>
        <Typography variant="body2">
          <strong>3. Entregas.</strong>
        </Typography>
        <Typography variant="body2">
          Último passo: a aba fica disponível quando não restar item Pendente e houver
          item aprovado ou para pedido para despachar. Agrupe quais serão entregues juntos.
        </Typography>
      </Stack>
      <Stack spacing={0.75}>
        <Typography variant="body2">
          <strong>4. Status da requisição.</strong>
        </Typography>
        <Box
          component="ul"
          sx={{ m: 0, pl: 2.5 }}
        >
          <Typography component="li" variant="body2">
            Aguardando enquanto houver item Pendente.
          </Typography>
          <Typography component="li" variant="body2">
            Aprovada quando a decisão fechou e ainda não há entrega.
          </Typography>
          <Typography component="li" variant="body2">
            Executando quando a primeira entrega é criada.
          </Typography>
          <Typography component="li" variant="body2">
            Finalizada quando não falta entrega nem pedido.
          </Typography>
          <Typography component="li" variant="body2">
            Rejeitada se nenhum item for atendido.
          </Typography>
          <Typography component="li" variant="body2">
            Cancelada quando cancelar a requisição.
          </Typography>
        </Box>
      </Stack>
    </Stack>
  </DialogDefaultV2>
);

ComoFuncionaDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

ComoFuncionaDialog.defaultProps = {
  open: false,
};

export default ComoFuncionaDialog;
